import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Field } from "@/components/shared/Common";
import { api, errMsg } from "@/lib/api";

export const REQ_ST = {
  borrador: ["inactivo", "Borrador"], enviada: ["pendiente", "Por aprobar"], aprobada: ["info", "Aprobada"], rechazada: ["bloqueado", "Rechazada"],
  cotizando: ["info", "En cotización"], oc_generada: ["activo", "OC generada"], cerrada: ["inactivo", "Cerrada"], anulada: ["bloqueado", "Anulada"],
};
export const PO_ST = {
  por_aprobar: ["pendiente", "Por aprobar (Finanzas)"], aprobada: ["info", "Aprobada"], rechazada: ["bloqueado", "Rechazada"], emitida: ["activo", "Emitida"],
  recepcion_parcial: ["pendiente", "Recepción parcial"], recibida: ["inactivo", "Recibida"], anulada: ["bloqueado", "Anulada"],
};
export const minQuotes = (net) => (net < 1e6 ? 1 : net < 3e6 ? 2 : net < 5e6 ? 3 : 4);

export const useComprasLookups = () => {
  const [l, setL] = useState({ ots: [], cost_centers: [], products: [], warehouses: [] });
  useEffect(() => { api.get("/compras/lookups").then((r) => setL(r.data)).catch(() => {}); }, []);
  return l;
};

export const NoteDialog = ({ cfg, onClose, onDone }) => {
  const [note, setNote] = useState("");
  useEffect(() => setNote(""), [cfg]);
  if (!cfg) return null;
  const go = async () => { try { await api.post(cfg.url, { note }); toast.success(cfg.ok); onDone(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="note-dialog">
        <DialogHeader><DialogTitle>{cfg.title}</DialogTitle></DialogHeader>
        <Field label={cfg.required ? "Motivo *" : "Comentario"}><Textarea data-testid="note-input" value={note} onChange={(e) => setNote(e.target.value)} /></Field>
        <DialogFooter><Button data-testid="note-confirm-btn" className="rounded-full" onClick={go}>Confirmar</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
